import packageJson from '../../../../package.json';

// 2.0.1: fix: Course Completed message was always in portuguese
// 2.0.2: feat: New languages
// 2.0.3: feat: Retry quiz
// 2.0.4: feat: Failed/passed status on quiz
// 2.0.5: fix: Audio component do not display when empty attributes
// 2.0.7: feat: Scorm 2004 3rd edition
// 2.0.8: feat: Updating imsmanifest with wildcards
// 2.0.20: feat: Preloading slide images, placeholder when loading, fade in pages
// 2.0.21: fix: compress/decompress json of suspendData (limit of Scorm 1.2 is 4096 chars)
// 3.0.0: feat: labels revamp + course player typescript + npm publish private package
// 3.0.1: fix: quiz saving answers with resourceId instead of text (make it short for suspend_data)
// 3.0.2: fix: the last fix broke correct check in quiz
// 3.0.3: feat: matching
// UNSTABLE: 3.0.6: fix: packages updated to avoid dependency error when installing this package
// UNSTABLE:  3.0.7: fix: infinite render on clearBackground and missing React import
// UNSTABLE:  3.0.8: fix: change fillInTheBlank params to match InputTag component on editor
// UNSTABLE:  3.0.10: refactor: sentence as a functional component on fill in the blanks
// UNSTABLE:  3.0.12: fix: labels and check correct on essay
// UNSTABLE:  3.0.18: fix: quiz order when added (editorMode) and randomize when all question in page was set
// 3.1.0: feat: new quiz types
// 3.1.1: fix: passing score, fill in the blanks, debounce setSuspendData
// 3.1.3: fix: navigation mode
// 3.1.5: feat: hyperlink, disable video seek, blink on next, scrollIntoView on quiz, matching on texts
// 3.1.7: feat: cannotProgressWhenFailed quiz config
// 3.2.0: feat: licensed package
export const VERSION = packageJson.version;
